import { create } from 'zustand';

type MobileWorkspaceState = {
  /** Panel id stack — last element is the active (top) panel. */
  stack: string[];
  pushPanel: (id: string) => void;
  popPanel: () => void;
  clearStack: () => void;
};

export const useMobileWorkspaceStore = create<MobileWorkspaceState>((set) => ({
  stack: [],

  pushPanel: (id) =>
    set((s) => ({
      stack: s.stack.includes(id) ? s.stack : [...s.stack, id],
    })),

  popPanel: () =>
    set((s) => ({
      stack: s.stack.slice(0, -1),
    })),

  clearStack: () => set({ stack: [] }),
}));
